const APP_SET_DETAILS = 'APP_SET_DETAILS';
const APP_SET_SPLASH = 'APP_SET_SPLASH';
const APP_SET_MAIN = 'APP_SET_MAIN';

const APP_SUBMIT = 'APP_SUBMIT';
const APP_SUBMIT_SUCCESS = 'APP_SUBMIT_SUCCESS';
const APP_SUBMIT_FAIL = 'APP_SUBMIT_FAIL';

const APP_LOAD = 'APP_LOAD';
const APP_LOAD_SUCCESS = 'APP_LOAD_SUCCESS';
const APP_LOAD_FAIL = 'APP_LOAD_FAIL';

export const onAppSetDetails = (attr, value) => ({type: APP_SET_DETAILS, attr, value })
export const onAppSetSplash = (attr, value) => ({type: APP_SET_SPLASH, attr, value })
export const onAppSetMain = (attr, value) => ({type: APP_SET_MAIN, attr, value })

export const onAppSubmit = () => ({type: APP_SUBMIT })
export const onAppSubmitSuccess = (response) => ({type: APP_SUBMIT_SUCCESS, response })
export const onAppSubmitFail = (e) => ({type: APP_SUBMIT_FAIL, e })

export const onAppLoad = (id) => ({type: APP_LOAD, id })
export const onAppLoadSuccess = (response) => ({type: APP_LOAD_SUCCESS, response })
export const onAppLoadFail = (e) => ({type: APP_LOAD_FAIL, e })
